<template>
  <div>
    <el-form-item label="提示文字">
      <el-input size="small" v-model="value.placeholder" placeholder="请设置提示语" />
    </el-form-item>
  </div>
</template>

<script>
import { getServiceItem } from '@/api/design'
export default {
  name: "ServiceItemInputConfig",
  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {

    };
  },
  created() {
    this.handleChange();
  },
  methods: {
    handleChange() {
      getServiceItem().then(res => {
        const result = []
        // 把 res 的结果首先按category字段进行分类，label、value为category字段，children为子级数据，放入result中
        // 然后继续把数据按mainCategoryCode字段进行分类，label为mainCategoryName、value为mainCategoryCode字段，children为子级数据。整体放入上一次分类结果的result的children中
        // 再继续把数据按categoryCode字段进行分类，label为categoryName、value为categoryCode字段，children为子级数据。整体放入上一次分类结果result的children的children中
        res.data.forEach(item => {
          let categoryItem = result.find(cat => cat.value === item.category);
          if (!categoryItem) {
            categoryItem = { label: item.category, value: item.category, children: [] };
            result.push(categoryItem);
          }

          // 按 mainCategoryCode 字段进行分类
          let mainCategoryItem = categoryItem.children.find(mainCat => mainCat.value === item.mainCategoryCode);
          if (!mainCategoryItem) {
            mainCategoryItem = { label: item.mainCategoryName, value: item.mainCategoryCode, children: [] };
            categoryItem.children.push(mainCategoryItem);
          }

          // 按 categoryCode 字段进行分类
          let categoryCodeItem = mainCategoryItem.children.find(catCode => catCode.value === item.categoryCode);
          if (!categoryCodeItem) {
            categoryCodeItem = { label: item.categoryName, value: item.categoryCode, children: [] };
            mainCategoryItem.children.push(categoryCodeItem);
          }
          // 处理 description 字段
          if (item.description != null) {
            const descriptions = item.description.split(/[，。\n]/).filter(desc => desc.trim() !== '');
            descriptions.forEach(desc => {
              if (!categoryCodeItem.children.includes(desc)) {
                categoryCodeItem.children.push({
                  value: {value: item.opsType, label: desc},
                  // value: item.opsType,
                  label: desc
                });
              }
            });
          }
        });
        this.value.options = result;
      });
    }
  }
};
</script>

<style lang="less" scoped></style>
